import { Grid, Typography } from '@mui/material'
import { HashLink } from 'react-router-hash-link'

export const SkipMenu = () => {
  return (
    <HashLink
      to="#content"
      aria-label="Click to skip the main navigation and focus on the main content"
      className="contentSkipButton"
    >
      <Grid
        container
        sx={{ width: '100%', height: '100%', alignContent: 'center', alignItems: 'center', justifyContent: 'center' }}
      >
        <Grid>
          <Typography color={'primary'}>Skip to content</Typography>
        </Grid>
      </Grid>
    </HashLink>
  )
}
